"use client";

import { useAnalytics } from "@analytics/provider/plausible";
import { useUserAccountsQuery } from "@saas/auth/lib/api";
import { useSession } from "@saas/auth/hooks/use-session";
import { useEffect, useRef } from "react";

export function OAuthSignupTracker() {
	const { user, loaded } = useSession();
	const { data: accounts } = useUserAccountsQuery();
	const { trackEvent } = useAnalytics();
	const hasTrackedRef = useRef(false);

	useEffect(() => {
		// Only track once per session
		if (!loaded || !user || hasTrackedRef.current || !accounts) {
			return;
		}

		// Check if user has a Google account
		const googleAccount = accounts.find(
			(account) => account.provider === "google",
		);

		if (!googleAccount) {
			return;
		}

		// Check if the Google account was created recently (within 1 minute)
		// This indicates a new signup via Google OAuth
		const accountCreatedAt = new Date(googleAccount.createdAt);
		const now = new Date();
		const timeDiff = now.getTime() - accountCreatedAt.getTime();
		const oneMinute = 60 * 1000; // 1 minute in milliseconds

		// Also check user creation time as fallback
		const userCreatedAt = new Date(user.createdAt);
		const userTimeDiff = now.getTime() - userCreatedAt.getTime();

		// If account or user was created within the last minute, it's a signup
		const isNewUser =
			timeDiff < oneMinute || userTimeDiff < oneMinute;

		// Track the event
		if (isNewUser) {
			trackEvent("Signup", {
				method: "google",
			});
		}
		// Note: We don't track login events here as per requirements

		hasTrackedRef.current = true;
	}, [user, loaded, accounts, trackEvent]);

	return null;
}

